// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AuditTrails__TableController from "./audit_trails/table_controller"
application.register("audit-trails--table", AuditTrails__TableController)

import Common__ModalController from "./common/modal_controller"
application.register("common--modal", Common__ModalController)

import Common__PopoverController from "./common/popover_controller"
application.register("common--popover", Common__PopoverController)

import Common__ResizableTablesController from "./common/resizable_tables_controller"
application.register("common--resizable-tables", Common__ResizableTablesController)

import Common__UrlUpdaterController from "./common/url_updater_controller"
application.register("common--url-updater", Common__UrlUpdaterController)

import Forms__ConfirmModalController from "./forms/confirm_modal_controller"
application.register("forms--confirm-modal", Forms__ConfirmModalController)

import Forms__CreateModalController from "./forms/create_modal_controller"
application.register("forms--create-modal", Forms__CreateModalController)

import Forms__DatePicker__DateRangesPopoverController from "./forms/date_picker/date_ranges_popover_controller"
application.register("forms--date-picker--date-ranges-popover", Forms__DatePicker__DateRangesPopoverController)

import Forms__SearchController from "./forms/search_controller"
application.register("forms--search", Forms__SearchController)

import Forms__TextFieldController from "./forms/text_field_controller"
application.register("forms--text-field", Forms__TextFieldController)

import Groups__GroupController from "./groups/group_controller"
application.register("groups--group", Groups__GroupController)

import Groups__SaveController from "./groups/save_controller"
application.register("groups--save", Groups__SaveController)

import Groups__SellerController from "./groups/seller_controller"
application.register("groups--seller", Groups__SellerController)

import Layout__SidebarController from "./layout/sidebar_controller"
application.register("layout--sidebar", Layout__SidebarController)

import Payments__BaseRefundRequestModalController from "./payments/base_refund_request_modal_controller"
application.register("payments--base-refund-request-modal", Payments__BaseRefundRequestModalController)

import Payments__PaymentsController from "./payments/payments_controller"
application.register("payments--payments", Payments__PaymentsController)

import Payments__RefundRequestModalController from "./payments/refund_request_modal_controller"
application.register("payments--refund-request-modal", Payments__RefundRequestModalController)

import Payments__RefundRequestUpdateModalController from "./payments/refund_request_update_modal_controller"
application.register("payments--refund-request-update-modal", Payments__RefundRequestUpdateModalController)

import Payments__RefundRequestsController from "./payments/refund_requests_controller"
application.register("payments--refund-requests", Payments__RefundRequestsController)

import Sellers__ManageSellersController from "./sellers/manage_sellers_controller"
application.register("sellers--manage-sellers", Sellers__ManageSellersController)

import Sellers__SearchController from "./sellers/search_controller"
application.register("sellers--search", Sellers__SearchController)

import Sessions__SessionTimeoutController from "./sessions/session_timeout_controller"
application.register("sessions--session-timeout", Sessions__SessionTimeoutController)

import Ui__ButtonController from "./ui/button_controller"
application.register("ui--button", Ui__ButtonController)

import Ui__NotificationsController from "./ui/notifications_controller"
application.register("ui--notifications", Ui__NotificationsController)

import Users__ManageGrantsController from "./users/manage_grants_controller"
application.register("users--manage-grants", Users__ManageGrantsController)
